export function filterOptions<T>(options: T[], search: string, getOptionLabel: (option: T) => string) {
  if (!search) return options;

  const searchLower = search.toLowerCase();
  return options.filter(option => {
    const label = getOptionLabel(option).toLowerCase();
    return label.includes(searchLower);
  });
}

export function sortOptions<T>(options: T[], search: string, getOptionLabel: (option: T) => string) {
  if (!search) return options;

  const searchLower = search.toLowerCase();
  return [...options].sort((a, b) => {
    const labelA = getOptionLabel(a).toLowerCase();
    const labelB = getOptionLabel(b).toLowerCase();

    const aStartsWithSearch = labelA.startsWith(searchLower);
    const bStartsWithSearch = labelB.startsWith(searchLower);

    if (aStartsWithSearch && !bStartsWithSearch) return -1;
    if (!aStartsWithSearch && bStartsWithSearch) return 1;

    return 0;
  });
}
